import { jsx as _jsx } from "react/jsx-runtime";
// Vendored from shadcn — see ./index.ts for provenance and our divergences.
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils";
function MessageGroup({ className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message-group",
        className: cn("flex min-w-0 flex-col gap-2", className),
        ...props
    });
}
function Message({ className, align = "start", ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message",
        "data-align": align,
        className: cn("group/message relative flex w-full min-w-0 gap-2 text-sm data-[align=end]:flex-row-reverse", className),
        ...props
    });
}
const messageAvatarVariants = cva("flex shrink-0 items-center justify-center", {
    variants: {
        variant: {
            /* Upstream's portrait slot: a fixed circle that crops whatever it holds. */ avatar: "size-8 self-end overflow-hidden rounded-full bg-muted text-muted-foreground group-has-data-[slot=message-footer]/message:-translate-y-8",
            /*
       * For a child that is already sized and styled — our assistant glyph is a
       * 28px component, so the circle would crop it and the muted fill would
       * sit behind it. Top-aligned, because an icon marks where the turn
       * starts rather than sitting beside its last line.
       */ icon: "self-start"
        }
    },
    defaultVariants: {
        variant: "avatar"
    }
});
function MessageAvatar({ className, variant = "avatar", ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message-avatar",
        className: cn(messageAvatarVariants({
            variant,
            className
        })),
        ...props
    });
}
function MessageContent({ className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message-content",
        className: cn("flex w-full min-w-0 flex-col gap-2.5 wrap-break-word group-data-[align=end]/message:*:data-slot:self-end", className),
        ...props
    });
}
function MessageHeader({ className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message-header",
        className: cn("flex max-w-full min-w-0 items-center px-3 text-xs font-medium text-muted-foreground group-has-data-[variant=ghost]/message:px-0", className),
        ...props
    });
}
function MessageFooter({ className, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        "data-slot": "message-footer",
        className: cn("flex max-w-full min-w-0 items-center px-3 text-xs font-medium text-muted-foreground group-has-data-[variant=ghost]/message:px-0 group-data-[align=end]/message:justify-end", className),
        ...props
    });
}
export { MessageGroup, Message, MessageAvatar, messageAvatarVariants, MessageContent, MessageFooter, MessageHeader };

//# sourceMappingURL=message.js.map